export default {
  'verificationcheck.verifycode': 'Bestätigungscode',
  'verificationcheck.gotoprofile': 'Profil Zutritt',
  'verificationcheck.entercode': 'Bestätigungscode eingeben',
  'verificationcheck.maintext':
    'Geben Sie bitte den Bestätigungscode hier ein, um weiter zu machen, der Code wurde an ......  gesendet ',
  'verificationcheck.continuetext':
    'überprüfen der Bestätigung . Mit dem Text weitermachen',
  'verificationcheck.evaluate': 'Bewerten',
  'verificationcheck.resendcode': 'Klicken Sie , um den Code erneut zu senden',
};
